import { MapPin, Phone, CalendarCheck, Clock } from "lucide-react";
import { BOOKSY_URL, PHONE_TEL, PHONE_DISPLAY, ADDRESS, MAPS_EMBED, HOURS } from "@/data/content";
import { Reveal } from "@/components/Reveal";

export const Contact = () => (
    <section id="ubicacion" data-testid="contact-section" className="scroll-mt-20 bg-white py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <Reveal>
                <p className="text-xs font-bold uppercase tracking-[0.3em] text-gold">
                    06 · Visítanos o llámanos
                </p>
                <h2 className="mt-3 font-display text-4xl font-extrabold tracking-tight text-ink sm:text-5xl">
                    Ubicación y Contacto
                </h2>
            </Reveal>

            <div className="mt-14 grid grid-cols-1 gap-10 lg:grid-cols-2">
                <Reveal className="h-full">
                    <div className="h-full overflow-hidden rounded-md border border-ink/10 shadow-sm">
                        <iframe
                            title="Mapa de Autolavado Rey Detailing"
                            data-testid="map-iframe"
                            src={MAPS_EMBED}
                            className="h-full min-h-[360px] w-full"
                            loading="lazy"
                            allowFullScreen
                            referrerPolicy="no-referrer-when-downgrade"
                        />
                    </div>
                </Reveal>

                <Reveal delay={0.1}>
                    <div className="flex h-full flex-col gap-8">
                        <div className="flex items-start gap-4">
                            <span className="rounded-sm bg-gold/10 p-3">
                                <MapPin className="h-5 w-5 text-gold" />
                            </span>
                            <div>
                                <h3 className="font-display text-lg font-bold text-ink">Dirección</h3>
                                <p data-testid="contact-address" className="mt-1 text-base text-gray-600">
                                    {ADDRESS}
                                </p>
                            </div>
                        </div>

                        <div className="flex flex-col gap-4 sm:flex-row">
                            <a
                                href={PHONE_TEL}
                                data-testid="contact-call-btn"
                                className="inline-flex flex-1 items-center justify-center gap-2 rounded-sm bg-ink px-6 py-4 text-base font-bold text-white transition-colors duration-200 hover:bg-gold hover:text-ink"
                            >
                                <Phone className="h-5 w-5" />
                                Llamar
                            </a>
                            <a
                                href={BOOKSY_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="contact-booking-btn"
                                className="inline-flex flex-1 items-center justify-center gap-2 rounded-sm bg-gold px-6 py-4 text-base font-bold text-ink transition-colors duration-200 hover:bg-[#a88a1e]"
                            >
                                <CalendarCheck className="h-5 w-5" />
                                Reservar Cita Online
                            </a>
                        </div>

                        <p className="text-sm font-semibold text-gray-500">
                            Teléfono: <a href={PHONE_TEL} data-testid="contact-phone-link" className="text-gold underline-offset-4 hover:underline">{PHONE_DISPLAY}</a>
                        </p>

                        <div>
                            <div className="mb-4 flex items-center gap-3">
                                <span className="rounded-sm bg-gold/10 p-3">
                                    <Clock className="h-5 w-5 text-gold" />
                                </span>
                                <h3 className="font-display text-lg font-bold text-ink">
                                    Horario de apertura
                                </h3>
                            </div>
                            <table data-testid="hours-table" className="w-full text-sm">
                                <tbody>
                                    {HOURS.map((row) => (
                                        <tr
                                            key={row.day}
                                            data-testid={`hours-row-${row.day.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "")}`}
                                            className="border-b border-ink/5 last:border-0"
                                        >
                                            <td className="py-2.5 font-bold text-ink">{row.day}</td>
                                            <td
                                                className={`py-2.5 text-right font-semibold ${
                                                    row.time === "Cerrado" ? "text-red-600" : "text-gray-600"
                                                }`}
                                            >
                                                {row.time}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </Reveal>
            </div>
        </div>
    </section>
);
